"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateChange = void 0;

var calculateChange = function calculateChange(e, skip, props, container) {
  e.preventDefault();
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (props.direction === 'vertical') {
    var offset;

    if (top < 0) {
      offset = 100;
    } else if (top > containerHeight) {
      offset = 0;
    } else {
      offset = 100 - top * 100 / containerHeight;
    }

    return offset;
  } else {
    var _offset;

    if (left < 0) {
      _offset = 0;
    } else if (left > containerWidth) {
      _offset = 100;
    } else {
      _offset = left * 100 / containerWidth;
    }

    return _offset;
  }
};

exports.calculateChange = calculateChange;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-slider/es5/src/helpers/slider.js
// module id = 1175
// module chunks = 0